import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop" error that Radix dialogs can trigger,
// which otherwise shows a full-screen CRA dev overlay in preview/QA.
const _roMsg = 'ResizeObserver loop';
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes(_roMsg)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
